var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgResetR = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 17,
  height: 17,
  viewBox: "0 0 17 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14.0679 4.52707L13.4493 3.90845C12.2777 2.73655 10.7283 2.01832 9.07679 1.88154C7.42532 1.74476 5.77887 2.19831 4.4304 3.16149C3.08193 4.12467 2.11889 5.53501 1.71264 7.14157C1.30639 8.74813 1.48327 10.4467 2.21181 11.9351C2.94035 13.4235 4.1733 14.6052 5.69128 15.2699C7.20926 15.9345 8.91383 16.0391 10.5017 15.565C12.0896 15.0909 13.4577 14.0689 14.3628 12.6807C15.2678 11.2926 15.6511 9.62837 15.4443 7.98419M14.0679 4.52707L10.3553 4.52795M14.0679 4.52707V0.814453",
  stroke: "black",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgResetR);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/reset-r.2f589f0ca0e909921c59a8e0b9aa58c2.svg";